<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex flex-wrap items-end">
                <div class="flex-grow">
                    <vs-button
                        v-if="isPermissionAdd()"
                        @click="addCamera"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-plus">
                        {{this.$t('news.addNews')}}
                    </vs-button>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :components="components"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="listNews"
                         :localeText="{noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                         :animateRows="true"
                         :pagination="true"
                         :paginationPageSize="paginationPageSize"
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                :max="maxPageNumbers"
                v-model="currentPage"/>
        </div>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../../ui-elements/Pagination.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import CellRendererContent from "./cell-renderer/CellRendererContent";
import { isAPI, isRouter } from "../../../../store/permission";
import { constAPI, constRouter } from "../../../../store/constant";

export default {
    components: {
        AgGridVue,

        // Cell Renderer
        Pagination,
        CellRendererActions,
        CellRendererContent,
    },
    data() {
        return {
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('news.humanCreate'),
                    field: 'employeeDetailResponseDTO.fullName',
                    width: 120
                },
                {
                    headerName: this.$t('news.department'),
                    field: 'departmentResponseDTO.departmentName',
                    width: 170
                },
                {
                    headerName: this.$t('news.title'),
                    field: 'title',
                    width: 120
                },
                {
                    headerName: this.$t('news.content'),
                    field: 'content',
                    cellRendererFramework: 'CellRendererContent',
                    width: 250,
                },
                {
                    headerName: this.$t('news.actions'),
                    field: 'actions',
                    width: 100,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            listNews: [],
            components: {
                CellRendererActions,
                CellRendererContent,
            },
        }
    },
    created() {
        this.initScreen();
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteNews'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('DELETE_NEWS', false);
            }
        },
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        }
    },
    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.news_add)
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },
        addCamera() {
            this.$router.push('/user/add-news').catch(() => {
            })
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        initScreen() {
            this.$vs.loading();
            this.$crm.get('/posts/find-all').then((response) => {
                this.listNews = response.data.map(item => {
                    if (item.employeeDetailResponseDTO == null) {
                        item.employeeDetailResponseDTO = {fullName: 'Quản trị viên'};
                    }
                    return item
                });
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        setTimeout(() => {
            if (this.listNews.length < 1) {
                document.getElementsByClassName("ag-overlay-no-rows-center")[0].innerText = "Chưa có bài viết.";
            }
        }, 200);
    }
}
</script>

<style scoped>

</style>
